import Mutations from "@/constants/store/mutations";

export default {
    [Mutations.set_auth_user](state, user) {
        state.user = _.extend(state.user, _.pick(user, [
            'name',
            'email',
            'roles',
            'companies',
            'setting',
            'avatar',
        ]))
    },
    [Mutations.set_taxonomies](state, payload) {
        state.taxonomies.data = payload.data;
        state.taxonomies.meta.fetched = true;
    },
    [Mutations.set_csrf](state, csrf) {
        state.csrf = csrf;
    },
    [Mutations.set_vehicle_years](state, payload) {
        state.vehicle_years.data = payload;
        state.vehicle_years.meta.fetched = true;
    },
    [Mutations.set_vehicle_makes](state, payload) {
        state.vehicle_makes.data = payload;
        state.vehicle_makes.meta.fetched = true;
    },
    [Mutations.set_vehicle_models](state, payload) {
        state.vehicle_models.data = payload;
        state.vehicle_models.meta.fetched = true;
    },
    [Mutations.set_vehicle_trims](state, payload) {
        state.vehicle_trims.data = payload;
        state.vehicle_trims.meta.fetched = true;
    }
}
